var _style, _defs, _rect, _polygon, _polygon2, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsharp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:url(#SVGID_3_);}\r\n\t.st2{fill:url(#SVGID_4_);}\r\n\t.st3{fill:url(#SVGID_5_);}\r\n\t.st4{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M44.6,11.4L26.8,1.1c-1-0.6-2.7-0.6-3.7,0L5.2,11.4c-1,0.6-1.9,2.1-1.9,3.2v20.6c0.1,1.4,0.8,2.5,1.9,3.2 L23,48.8c1,0.6,2.7,0.6,3.7,0l17.8-10.3c1.2-0.8,1.8-1.9,1.9-3.2V14.6C46.5,13.4,45.7,12.1,44.6,11.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.5562,
    y1: 1.959,
    x2: 79.2253,
    y2: -15.5366,
    gradientTransform: "matrix(0.8974 0 0 -0.8974 -25.6923 22.0513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B009B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#390086"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 12.4,
    className: "st1",
    width: 25.4,
    height: 25.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.5288,
    y1: -10.6088,
    x2: 59.061,
    y2: -29.2092,
    gradientTransform: "matrix(0.8974 0 0 -0.8974 -25.6923 22.0513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#340084"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#290064"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "49.8,39.3 17.2,20.4 0.5,20.4 0.5,51.7 49.8,51.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.1427,
    y1: 17.9747,
    x2: 60.0159,
    y2: -1.0622,
    gradientTransform: "matrix(0.8974 0 0 -0.8974 -25.6923 22.0513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A47EDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9866D3"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "0.5,39.1 49.8,10.5 49.8,-0.8 0.5,-0.8  "
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "c",
    className: "st4",
    d: "M10.2,25c-0.1-14.5,19.3-20.8,27.6-7.4l-6.4,3.7c-3.9-6.4-13.5-4.1-13.8,3.7c0.1,7.2,9.5,10.5,13.8,3.7 l6.4,3.7C30.5,45.2,10.6,40.6,10.2,25z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sharp"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "34.6,20.8 35.8,20.8 35,28.9 33.8,28.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "37.2,20.8 38.4,20.8 37.6,28.9 36.4,28.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.2,
    y: 22.7,
    className: "st4",
    width: 6.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 25.6,
    className: "st4",
    width: 6.1,
    height: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsharp);
export default __webpack_public_path__ + "static/media/csharp.eea06aa6e96f139cf5216df9e369761a.svg";
export { ForwardRef as ReactComponent };